// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"659de775","550":"659de775","585":"659de775","663":"659de775","929":"659de775","977":"659de775"}[chunkId] + ".chunk.css";
};